import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/information", // 信息中心
      name: "information",
      component: () => import("./views/Information.vue")
    },
    {
      path: "/about", // 关于我们
      name: "about",
      component: () => import("./views/About.vue")
    },
    {
      path: "/recruit", // 人才招聘
      name: "recruit",
      component: () => import("./views/Recruit.vue")
    },
    {
      path: "/memberCenter", // 会员中心
      name: "memberCenter",
      component: () => import("./views/MemberCenter.vue")
    },
    {
      path: "/internationalReferral", // 国际转诊
      name: "internationalReferral",
      component: () => import("./views/InternationalReferral.vue"),
      meta: {
        title: "国际转诊"
      }
    },
    {
      path: "/BlueCross",
      name: "BlueCross",
      component: () => import("./views/BlueCross.vue"),
      meta: {
        title: "蓝十医旅"
      }
    },
    {
      path: "/SeeDoctor",
      name: "SeeDoctor",
      component: () => import("./views/SeeDoctor.vue"),
      meta: {
        title: "出国看病"
      }
    },
    {
      path: "/BestMedicalCare", // 优诊通
      name: "BestMedicalCare",
      component: () => import("./views/BestMedicalCare.vue"),
      meta: {
        title: "优诊通"
      }
    },
    {
      path: "/HelloI18n",
      name: "HelloI18n",
      component: () => import("./components/HelloI18n.vue")
    },
    {
      path: "/NewsDetail", // 新闻详情页
      name: "NewsDetail",
      component: () => import("./views/NewsDetail.vue")
    },
    {
      path: "/BlueCross1", // 新闻详情页
      name: "BlueCross1",
      component: () => import("./views/BlueCross1.vue")
    },
    {
      path: "/KangBao", // 新闻详情页
      name: "KangBao",
      component: () => import("./views/KangBao.vue")
    },
    {
      path: "/KangLogin",
      name: "KangLogin",
      component: () => import("./views/KangLogin.vue")
    },
    {
      path: "/StaffLogin",
      name: "StaffLogin",
      component: () => import("./views/StaffLogin.vue")
    }
  ]
});
